<template>
    <KNotificationCard
        :title="notifica.title"
        :body="notifica.body"
        :key="notifica.id"
        :showPrimaryButton="showNotificationPrimaryButton(notifica)"
        :showSecondaryButton="showNotificationSecondaryButton(notifica)"
        :primaryButton="primaryButton"
        :secondaryButton="secondaryButton"
        :level="getNotificationLevel(notifica)"
        @on-primary-button-click="onNotificationPrimaryButtonClick(notifica)"
        @on-secondary-button-click="onNotificationSecondaryButtonClick(notifica)">
        <template #pre-info-title>
            <span class="mr-3 uppercase notifica-data px-3">
                {{ toDDMMMMString(notifica.date) }}
            </span>
        </template>
    </KNotificationCard>
</template>

<script lang="ts" setup>

import { CesfNotification } from '@/services/cesf/models';
import {ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useBuildingSiteStore } from "@/modules/buildingsite/store";
import { useMultichannelNotificationsStore } from "@/modules/multichannelNotifications/store";
import { useFilters } from "@k-digitale/kappa";

const primaryButton = ref<any>();
const secondaryButton = ref<any>();

const { toDDMMMMString } = useFilters();

const props = defineProps<{
    notifica: CesfNotification,
  }>();

const getNotificationLevel = (notification : CesfNotification) => {
    if(notification.type == "ExpiredCourse"){
        return "danger";
    } else{
        return "info";
    }
}

const showNotificationPrimaryButton = (notification : CesfNotification) => {
    if(notification.type == "CantiereDocumentUpload"){
        primaryButton.value = { label: 'DETTAGLI' };
        return true;
    }else if(notification.type == "ExpiredCourse"){
        primaryButton.value = { label: 'DETTAGLI' };
    } else{
        return false;
    }
}

const showNotificationSecondaryButton = (notification : CesfNotification) => {
    if(notification.type == "CantiereDocumentUpload"){
        secondaryButton.value = { label: 'SCARICA PDF' }
        return true;
    } else{
        return false;
    }
}

const router = useRouter();
const multichannelNotificationsStore = useMultichannelNotificationsStore();
const onNotificationPrimaryButtonClick = async (notification: CesfNotification) => {
    if(notification.type == "CantiereDocumentUpload"){
        await multichannelNotificationsStore.setNotificationSeen(notification.id);
        router.push({
            path: `/buildingsite/detail/${notification.metaData.cantiereId}`
        });
    } else if(notification.type == "ExpiredCourse"){
        router.push({
            path: `/employee/detail/${notification.metaData}/attestati`
        });
    }
};

const buildingSiteStore = useBuildingSiteStore();
const onNotificationSecondaryButtonClick: any = async function (notification: CesfNotification) {
    if(notification.type == "CantiereDocumentUpload"){
        const result = await buildingSiteStore.downloadDocumentoCantiere(
            notification.metaData.cantiereId,
            notification.metaData.documentId);
    }
};

</script>

<style scoped lang="scss">
.notifica-data {
    color: #757575;
    font-size: 14px;
    background-color: #f8f8f8;
    border-radius: 4px;
}
</style>